import { render, staticRenderFns } from "./BldUniDate.vue?vue&type=template&id=8046086c&scoped=true&"
import script from "./BldUniDate.vue?vue&type=script&lang=js&"
export * from "./BldUniDate.vue?vue&type=script&lang=js&"
import style0 from "./BldUniDate.vue?vue&type=style&index=0&id=8046086c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8046086c",
  null
  
)

export default component.exports